export default {
  data() {
    return {};
  },
  methods: {
    MATOMO_trackExternalLink(url, origin) {
      this.onProduction ? window._paq.push(["trackLink", url, origin]) : 0;
    }
  },
  computed: {
    onProduction() {
      return process.env.VUE_APP_SENTRY_ENVIRONMENT === "production";
    }
  }
};
